export default "__VITE_ASSET__DLmOYMjk__"